<template>
    <section>
        <CalendarDisplay />
    </section>
</template>

<script>
import CalendarDisplay from '@/components/CalendarDisplay.vue';

export default {
    name: 'HomeView',
    components: {
        CalendarDisplay
    }
}
</script>

<style scoped></style>